const businessTab = {
  foundInSelectedSectors: 'وفقاً للخيارات المحددة، هناك',
  businesses: 'نقطة اهتمام',
};

export default businessTab;
